import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../../createApiConfig';


export const uMOpsApi = createApi({
  reducerPath: 'uMOpsApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['ops'],
  endpoints: builder => ({
    // Get overall performance - new unified endpoint
    getOverallPerformance: builder.query({
      query: (params) => ({
        url: '/users/ops/overall-performance/',
        params,
      }),
      providesTags: ['ops']
    }),
  }),
});

export const {
  useGetOverallPerformanceQuery,
} = uMOpsApi;
